


















































import { Component, Vue, Prop } from "vue-property-decorator";
import PlantCard from "@/components/PlantCard.vue";
import { Plant } from "@/types";

function compare(a: Plant, b: Plant) {
  if (a.name < b.name) {
    return -1;
  }
  if (a.name > b.name) {
    return 1;
  }
  return 0;
}

function shuffleArray<T>(array: T[]) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
}

@Component({
  components: {
    PlantCard,
  },
})
export default class PlantGroup extends Vue {
  @Prop() readonly plants!: Plant[];
  randomOrder: string = "random";
  filter: string = "";
  get filteredPlants() {
    if (this.filter) {
      const filter = this.filter.toLowerCase();
      return this.plants.filter(
        (plant) =>
          plant.name.toLowerCase().match(filter) ||
          (plant.localName && plant.localName.toLowerCase().match(filter)),
      );
    }
    return this.plants;
  }

  get orderedPlants() {
    if (this.randomOrder === "random") {
      const orderedPlants = [...this.filteredPlants];
      shuffleArray(orderedPlants);
      return orderedPlants;
    }
    return this.filteredPlants.sort(compare);
  }
}
